/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBookingParallel201, PostApiBookingParallelMutationRequest, PostApiBookingParallelMutationResponse, PostApiBookingParallelQueryParams } from "../entities/PostApiBookingParallel";
import { modelsBookingGroupOutputSchema } from "./models/bookingGroupOutputSchema";
import { modelsBookingParallelInputSchema } from "./models/bookingParallelInputSchema";
import { z } from "zod/v4";

export const postApiBookingParallelQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<PostApiBookingParallelQueryParams>

/**
 * @description Created
 */
export const postApiBookingParallel201Schema = z.lazy(() => modelsBookingGroupOutputSchema) as unknown as z.ZodType<PostApiBookingParallel201>

/**
 * @description Данные параллельной записи
 */
export const postApiBookingParallelMutationRequestSchema = z.lazy(() => modelsBookingParallelInputSchema) as unknown as z.ZodType<PostApiBookingParallelMutationRequest>

export const postApiBookingParallelMutationResponseSchema = z.lazy(() => postApiBookingParallel201Schema) as unknown as z.ZodType<PostApiBookingParallelMutationResponse>